export const columnsDataDpIdOverview = [
  {
    Header: 'DP ID',
    accessor: 'dpid',
  },
  {
    Header: 'DP NAME',
    accessor: 'name',
  },
  {
    Header: 'TYPE',
    accessor: 'type',
  },
  {
    Header: 'ACTIONS',
    accessor: 'actions',
  }

];
